export const permissionsUsersFull = ["users-full", "everything-full"];
